/*
 * @description 获取日期mixins
 * @method regNum 获取utc时间
 * @filter $reg_comdify 数字添加千分位
 */
export default {
  filters: {
    /* 
     * @description 实现千分位
     * @param n:string or number 要转换的数字
     * @return n1:string 转换后的数字
     */
    $reg_comdify(n) {
      if (typeof n === 'undefined') n = 0;
      let re = /\d{1,3}(?=(\d{3})+$)/g,
        n1 = n.toString().replace(/^(\d+)((\.\d+)?)$/, (s, s1, s2) => s1.replace(re, '$&,') + s2);
      return n1;
    }
  },
  methods: {
    /*
	 * @description 限制input只能输入数字
	 * @param e:obj event对象
	 * @param bit:number 限制输入的位数
	 * @param min:number 最小值
	 * @param max:number 最大值
     * @return string 格式化后的数字字符串
	 */
    regNum(e, bit, min = false, max = false) {
      let value = e.target.value;
      switch (bit) {
        case 0:
          value = value.replace(/[^\d]/g, '');
          break;
        case 2:
          value = value.replace(/[^\d.]/g, ''); //清除"数字"和"."以外的字符
          value = value.replace(/^\./g, ''); //验证第一个字符是数字
          value = value.replace(/\.{2,}/g, '.'); //只保留第一个, 清除多余的
          value = value
            .replace('.', '$#$')
            .replace(/\./g, '')
            .replace('$#$', '.');
          value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
        //不限位数
        case -1:
          value = value.replace(/[^\d.]/g, ''); //清除"数字"和"."以外的字符
        default:
          break;
      }
      if ((min || min === 0) && value < min) value = min;
      if ((max || max === 0) && value > max) value = max;
      e.target.value = value;
      return value;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/reg.js